<template>
    <div class="col-lg-12 px-0">
        <card class="bg-none shadow-none mb-0">
            <div class="flex-between">
                <h2 slot="header" class="card-title">
                    Future Delivery Requests
                </h2>
                <base-button
                    v-if="showAddButton"
                    type="primary"
                    class="btn-fill"
                    @click="showAddFutureDeliveryRequest = true"
                >
                    Add Future Delivery Request
                </base-button>
            </div>
            <table-search-and-pagination
                hide-per-page
                :table-data="futureDeliveries"
                :extra-search-props="extraSearchProps"
                @dataUpdated="queriedData = $event"
            >
                <template>
                    <future-delivery-requests-table
                        :future-deliveries="queriedData"
                        :exclude-columns="excludedColumns"
                        @rowClicked="
                            $emit('futureDeliveryRequestRowClicked', $event)
                        "
                    />
                </template>
            </table-search-and-pagination>
        </card>
        <future-delivery-request-detail
            v-if="showFutureDeliveryRequestSummary"
            :future-request="selectedFutureDeliveryRequest"
            :show="showFutureDeliveryRequestSummary"
            @update:show="
                $emit('update:showFutureDeliveryRequestSummary', $event)
            "
        />
        <new-future-delivery-request
            v-if="showAddFutureDeliveryRequest"
            :show="showAddFutureDeliveryRequest"
            @update:show="showAddFutureDeliveryRequest = $event"
        />
    </div>
</template>

<script>
import FutureDeliveryRequestDetail from "src/modules/FutureDeliveryRequest/FutureDeliveryRequestDetail";
import NewFutureDeliveryRequest from "src/modules/FutureDeliveryRequest/NewFutureDeliveryRequest";
import FutureDeliveryRequestsTable from "src/modules/FutureDeliveryRequest/FutureDeliveryRequests/_components/FutureDeliveryRequestsTable";
import TableSearchAndPagination from "src/components/TableSearchAndPagination";

export default {
    name: "FutureDeliveryRequests",
    components: {
        FutureDeliveryRequestDetail,
        NewFutureDeliveryRequest,
        FutureDeliveryRequestsTable,
        TableSearchAndPagination,
    },
    props: {
        showAddButton: {
            type: Boolean,
            default: false,
        },
        excludedColumns: {
            type: Array,
            default: () => [],
        },
        futureDeliveries: {
            type: Array,
            default: () => [],
        },
        showFutureDeliveryRequestSummary: {
            type: Boolean,
            required: true,
        },
        selectedFutureDeliveryRequest: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            extraSearchProps: ["requestDetails.jobNumber"],
            queriedData: [],
            showAddFutureDeliveryRequest: false,
        };
    },
};
</script>

<style module>
.shadow-none {
    box-shadow: none;
}
.bg-none {
    background: none;
}
</style>
